/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PopupConfigInfoRespVo } from './PopupConfigInfoRespVo';
import {
    PopupConfigInfoRespVoFromJSON,
    PopupConfigInfoRespVoFromJSONTyped,
    PopupConfigInfoRespVoToJSON,
    PopupConfigInfoRespVoToJSONTyped,
} from './PopupConfigInfoRespVo';

/**
 * 
 * @export
 * @interface PageDataPopupConfigInfoRespVo
 */
export interface PageDataPopupConfigInfoRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataPopupConfigInfoRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataPopupConfigInfoRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataPopupConfigInfoRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<PopupConfigInfoRespVo>}
     * @memberof PageDataPopupConfigInfoRespVo
     */
    records?: Array<PopupConfigInfoRespVo>;
}

/**
 * Check if a given object implements the PageDataPopupConfigInfoRespVo interface.
 */
export function instanceOfPageDataPopupConfigInfoRespVo(value: object): value is PageDataPopupConfigInfoRespVo {
    return true;
}

export function PageDataPopupConfigInfoRespVoFromJSON(json: any): PageDataPopupConfigInfoRespVo {
    return PageDataPopupConfigInfoRespVoFromJSONTyped(json, false);
}

export function PageDataPopupConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataPopupConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(PopupConfigInfoRespVoFromJSON)),
    };
}

export function PageDataPopupConfigInfoRespVoToJSON(json: any): PageDataPopupConfigInfoRespVo {
    return PageDataPopupConfigInfoRespVoToJSONTyped(json, false);
}

export function PageDataPopupConfigInfoRespVoToJSONTyped(value?: PageDataPopupConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(PopupConfigInfoRespVoToJSON)),
    };
}

